import { Group, Stack } from '@mantine/core';
import FormInputGroup from 'components/forms/FormInputGroup';
import P2Medium from 'components/typography/P2Medium';
import { ChastiaConfigForm } from 'components/forms/remote-source/config/types';
import ISObjectPairingRow from 'components/forms/remote-source/config/chastia-config-form/is-objects/ISObjectPairingRow';
import { IconPlus } from '@tabler/icons-react';
import { randomId } from '@mantine/hooks';
import Button from 'components/Button';

interface ISObjectsProps {
  form: ChastiaConfigForm;
}

/**
 * Sub-form for IS Object pairings.
 */
export default function ISObjects({ form }: ISObjectsProps) {
  return (
    <FormInputGroup groupTitle="Mapovanie IS Objektov">
      <Stack spacing={8}>
        <Group className="grid grid-cols-[1fr_1fr_1fr_24px_1fr_1fr_88px] items-center gap-y-0">
          <P2Medium>ID Štruktúry</P2Medium>
          <P2Medium>ID Úrovne</P2Medium>
          <P2Medium>ID IS Objektu</P2Medium>
          <div></div>
          <P2Medium>Vlastnosť</P2Medium>
          <P2Medium>Hodnota</P2Medium>
        </Group>

        {form.values.objects.map((item, index) => (
          <ISObjectPairingRow key={item.key} form={form} item={item} index={index} />
        ))}

        <Group mt={8}>
          <Button size="md" leftIcon={<IconPlus />} onClick={() => form.insertListItem('objects', { key: randomId() })}>
            Pridat riadok
          </Button>
        </Group>
      </Stack>
    </FormInputGroup>
  );
}
